import React from 'react';
import '../../App.css';


function Calendar() {

  return (
    <>
        <div className='hero-container event half'>
        <h1>Calendar</h1>
        </div>

          <iframe
          src="https://gcftx.ccbchurch.com/goto/events/public?focus=month&view=calendar" 
          scrolling='no'
          className='events-frame'
          >
          </iframe>
    </>
  );
}

export default Calendar;